import { render, staticRenderFns } from "./CustVessel.vue?vue&type=template&id=2d107f6a&scoped=true"
import script from "./CustVessel.vue?vue&type=script&lang=js"
export * from "./CustVessel.vue?vue&type=script&lang=js"
import style0 from "./CustVessel.vue?vue&type=style&index=0&id=2d107f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d107f6a",
  null
  
)

export default component.exports